export default "/images/vendor/flag-icon-css/flags/4x3/dj.svg?76f4cdf5eb6411038bc5994153148b04";